import * as React from 'react'
import { ReactElement } from 'react'
import BaseCombobox, { BaseComboboxProps } from './BaseCombobox'

type Props = Partial<BaseComboboxProps<InjuryType>> & Pick<BaseComboboxProps<InjuryType>, 'onOptionSelect'>

type InjuryType = {
    key: string
    label: string
    shortLabel?: string
}

const InjuryTypes: InjuryType[] = [
    {
        key: 'ARM_HAND_INJURY',
        label: 'Arm- en handletsel',
        shortLabel: 'Arm/Hand',
    },
    {
        key: 'LEG_FOOT_INJURY',
        label: 'Been- en voetletsel',
        shortLabel: 'Been/Voet',
    },
    {
        key: 'BURNS',
        label: 'Brandwonden',
        shortLabel: 'Brand',
    },
    {
        key: 'VARIOUS_INJURIES',
        label: 'Diverse letsels',
        shortLabel: 'Divers',
    },
    {
        key: 'SPINAL_CORD_PARALYSIS',
        label: 'Dwarslaesie en verlamming',
        shortLabel: 'Dwarslaesie/Verlamming',
    },
    {
        key: 'DYSTROPHIC_INJURY',
        label: 'Dystrofisch letsel',
        shortLabel: 'Dystrofisch',
    },
    {
        key: 'SIMPLE_BITE_SCARS',
        label: 'Eenvoudige bijtwonden/littekens',
        shortLabel: 'Bijtwond/Litteken',
    },
    {
        key: 'SIMPLE_BRUISES',
        label: 'Eenvoudige kneuzingen',
        shortLabel: 'Kneuzing',
    },
    {
        key: 'SEVERE_MULTIPLE_INJURY',
        label: 'Ernstig multiple letsel',
        shortLabel: 'Veelvoudig',
    },
    {
        key: 'BRAIN_INJURY',
        label: 'Hersenletsel',
        shortLabel: 'Hersenen',
    },
    {
        key: 'CONCUSSION',
        label: 'Hersenschudding',
    },
    {
        key: 'HIP_PELVIS_INJURY',
        label: 'Heup/Bekken',
    },
    {
        key: 'HEAD_INJURY',
        label: 'Hoofdletsel',
        shortLabel: 'Hoofd',
    },
    {
        key: 'INTERNAL_INJURY',
        label: 'Inwendig letsel',
        shortLabel: 'Inwendig',
    },
    {
        key: 'JAW_TEETH_INJURY',
        label: 'Kaak- en gebitsletsel',
        shortLabel: 'Kaak/Gebit',
    },
    {
        key: 'FACIAL_BODY_DISFIGUREMENT',
        label: 'Ontsiering gelaat en lichaam',
        shortLabel: 'Gelaat/Lichaam',
    },
    {
        key: 'EYE_INJURY',
        label: 'Oogletsel',
        shortLabel: 'Oog',
    },
    {
        key: 'EAR_INJURY_HEARING_LOSS',
        label: 'Oor/Gehoor',
    },
    {
        key: 'DECEASED',
        label: 'Overleden',
    },
    {
        key: 'PSYCHOLOGICAL_INJURY',
        label: 'Psychisch letsel',
        shortLabel: 'Psychisch',
    },
    {
        key: 'BACK_INJURY',
        label: 'Rugletsel',
        shortLabel: 'Rug',
    },
    {
        key: 'SHOCK_DAMAGE',
        label: 'Schokschade',
        shortLabel: 'Schok',
    },
    {
        key: 'SHOULDER_CHEST_INJURY',
        label: 'Schouder- en borstkasletsel',
        shortLabel: 'Schouder/Borstkas',
    },
    {
        key: 'LOSS_OF_SMELL_TASTE',
        label: 'Verlies van reuk en smaak',
        shortLabel: 'Reuk/Smaak',
    },
    {
        key: 'UNKNOWN_WOUND',
        label: 'Verwonding onbekend',
        shortLabel: 'Onbekend',
    },
    {
        key: 'WHIPLASH',
        label: 'Whiplash',
    },
    {
        key: 'NERVE_INJURY',
        label: 'Zenuwletsel',
        shortLabel: 'Zenuw',
    },
]

export default function InjuryTypeCombobox(props: Props): ReactElement {
    return (
        <BaseCombobox<InjuryType>
            entities={InjuryTypes}
            alphabetical
            getEntityShortLabel={option => option.shortLabel || option.label}
            getEntityLabel={option => option.label}
            getEntityValue={option => option.key}
            multiselect
            {...props}
        />
    )
}
